<template>
	<div>
		<div class="view-framework">
			<userLeft></userLeft>
			<div class="view-framework-body">
				<div class="view-framework-main">
					<div class="box">
						<h2 class="box-caption">我要提现</h2>
						<div class="userform">
							<div class="form-group">
								<label class="form-label">提现方式：</label>
								<div class="form-element">
									<ul class="btn-group clearfix">
										<li class="" :class="{selected:tabIndex === 1}" @click="trigerTab(1)">
											<a class="btn" href="javascript:;">
												<span class="icon">
													<i class="iconfont icon-zhifubaozhifu"></i>
												</span>
												提现至支付宝
											</a>
										</li>
										<li class="" :class="{selected:tabIndex === 2}" @click="trigerTab(2)">
											<a class="btn" href="javascript:;">
												<span class="icon">
													<i class="iconfont icon-yinhangqia-xianxing"></i>
												</span>
												提现至银行卡
											</a>
										</li>
										<li class="" :class="{selected:tabIndex === 3}"  @click="trigerTab(3)">
											<a class="btn" href="javascript:;">
												<span class="icon">
													<i class="iconfont icon-weixin2"></i>
												</span>
												提现至微信
											</a>
										</li>
									</ul>
								</div>
							</div>
							<div v-if="withdrawType[tabIndex-1] === 1">
								<div class="form-group">
									<label class="form-label">收款姓名：</label>
									<div class="form-element">
										{{name?name:"请先实名"}}
										<span class="label label-primary" v-if="name">已实名</span>
										<router-link v-else class="text-blue" :to="{path:'/real'}">马上去实名</router-link>
									</div>
								</div>
								<div class="form-group">
									<label class="form-label">{{tabIndex === 1?"支付宝账户：":tabIndex=== 2?"银行卡账户：":"微信账户："}}</label>
									<div class="form-element">
										<ul class="form-combobox">
											<li v-for="(item,index) in withdrawList" :key='index'>
												<label class="radio">
													<el-radio v-model="radio" :label="index">
														<!-- <span class="radio-text"> -->
															<!-- <div class="cashcard-name"> -->
															<i class="text-blue">{{tabIndex === 1?'支付宝提现':tabIndex === 2?'银行卡提现':'微信提现'}}</i>
															<span style="margin-left: 20px;">
																<strong>{{tabIndex === 1?item.account:tabIndex === 2?item.account:item.nickName}}</strong>
															</span>
													</el-radio>

												</label>
											</li>
										</ul>
										<div class="form-tips">
											<a class="text-blue" @click="oepnAdd()" href="javascript:;">+ 添加{{tabIndex === 1?'支付宝':tabIndex===2?'银行卡':"微信"}}帐号</a>
											<span class="sep">|</span>
											<router-link class="text-blue" :to="{path:'/withdrawAccount?type='+tabIndex}">管理</router-link>
										</div>
									</div>
								</div>
								<div class="form-group">
									<label class="form-label">
										<em>*</em>
										 提现金额：
									</label>
									<div class="form-element">
										<input class="form-control form-control-short" type="number" v-model="face" placeholder="请输入要提现的金额"/>
										<div class="form-tips">
											元
											<span class="sep">|</span>
											可提现金额：{{userList.balance}}
										</div>
										<div class="help-block">
											 <p>单笔提现不能超过5000元</p>
										</div>
									</div>
								</div>
								<div class="form-group-btn">
									<button class="btn btn-primary" @click="withdrawPrice">确定提现</button>
									<div class="help-block" style="float: none;">
										<p v-html="faceNoticle"></p>
									</div>
								</div>
							</div>
							<div v-if="withdrawType[tabIndex-1] != 1">
								<div class="form-group">
									<label class="form-label">&nbsp;</label>
									<div class="form-element">
										<div class="alert alert-warning form-alert">
											<div class="form-alert-icon">
												<i class="iconfont icon-houqiweihuweihuweihuguanli"></i>
											</div>
											<h4>{{tabIndex === 1?'支付宝':tabIndex===2?"银行卡":"微信"}}提现接口维护中</h4>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<pop ref="addPop" :name="name"></pop>
	</div>
</template>

<script>
	import pop from '../common/withdraw/pop.vue'
	export default{
		data(){
			return{
				tabIndex:1,
				faceNoticle:"",
				name:"",
				withdrawType:[],
				withdrawList:[],
				faceList:[],
				radio:0,
				userList:[],
				face:""
			}
		},
		components:{
			pop
		},
		created() {
			this.getUserList()
			this.getNoticle()
			this.getUserRealStatus()
			this.getWithdrawType()
			this.getWithdrawList()
		},
		methods:{
			// 切换提现方式
			trigerTab(index){
				this.tabIndex = index
				this.getNoticle()
				this.getWithdrawList()
			},
			oepnAdd(){
				if(!this.userList.phone){
					this.$message({
						message: '请先绑定手机号',
						type: 'warning'
					});
					return
				}
				if(!this.name){

					this.$message({
						message: '请先实名',
						type: 'warning'
					});
					return
				}
				if(this.tabIndex === 1){
					this.$refs.addPop.addZfb()
				}else if (this.tabIndex === 2){
					this.$refs.addPop.addBank()
				}else{
					this.$refs.addPop.getQrcode()
				}
			},
			withdrawPrice(){
				if(!this.userList.phone){
					this.$message({
						message: '请先绑定手机号',
						type: 'warning'
					});
					return
				}
				if(!this.name){

					this.$message({
						message: '请先实名',
						type: 'warning'
					});
					return
				}
				let wid = this.withdrawList[this.radio].id
				let token = localStorage.getItem('token')
				this.$api.withdrawPrice({
					token: token,
					prices: this.face,
					prices_type: this.tabIndex,
					w_id:wid,
					code:"",
					advanced:2
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						window.location.reload();
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			getUserList(){
				let token = localStorage.getItem('token')
				this.$api.userInfo({
					token
				}).then(result => {
					if(result.code === 1){
						localStorage.setItem("userInfo",JSON.stringify(result.data))
						this.userList = result.data
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			// 提现账号列表
			getWithdrawList(){
				let token = localStorage.getItem('token')
				this.$api.getWithdrawList({
					token:token,
					type:this.tabIndex
				}).then(res => {
					if(res.code === 1){

							this.withdrawList = res.data
							this.faceList = res.data[0]


					}
				})
			},
			// 提现方式
			getWithdrawType(){
				let token = localStorage.getItem('token')
				this.$api.getWithdrawType({
					token:token
				}).then(res => {
					if(res.code === 1){
						this.withdrawType.push(res.data.aliPay)
						this.withdrawType.push(res.data.bankPay)
						this.withdrawType.push(res.data.wxPay)
					}
				})
			},
			// 实名信息
			getUserRealStatus(){
				let token = localStorage.getItem('token')
				this.$api.getUserRealStatus({
					token:token,
					type:1
				}).then(res => {
					if(res.code === 1){
						if(res.data.name){
							this.name = res.data.name
						}
					}
				})
			},
			// 提现备注
			getNoticle(){
				let token = localStorage.getItem('token')
				this.$api.getWithdrawNotice({
					token:token,
					type:this.tabIndex
				}).then(res => {
					if(res.code === 1){
						this.faceNoticle = this.HTMLDecode(res.data.content)
					}
				})
			},
			HTMLDecode(text) {
				var temp = document.createElement("div");
				temp.innerHTML = text;
				var output = temp.innerText || temp.textContent;
				temp = null;
				return output;
			},
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/user/withdraw.vue